module.exports = __webpack_public_path__ + "static/assets/2659c05c51412f56c36a02beb5758cac.png";